export default function clamp( value, min, max ){
    return value < min ? min: value > max ? max : value;
}